import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from '@angular/router';

import { TrailerRoutingModule } from './trailer-routing.module';
import { TrailerListComponent } from './trailer-list/trailer-list.component';
import { TrailerAddComponent } from './trailer-add/trailer-add.component';
import { TrailerEditComponent } from './trailer-edit/trailer-edit.component';
import { TrailerActionsComponent } from './trailer-actions/trailer-actions.component';

@NgModule({
  declarations: [
    TrailerListComponent,
    TrailerAddComponent,
    TrailerEditComponent,
    TrailerActionsComponent
  ],
  imports: [
    CommonModule,
    TrailerRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    AgGridModule,
    RouterModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TrailerModule { }
